<template>
    <div class="mandati">
        <gnetHeader></gnetHeader>

        <gnetTabBar
            v-bind:titoloapp="$store.getters.appname"
            v-bind:tabs="$store.state.tabs"
            v-bind:active_tab="$store.state.active_tab"
            v-on:click="changeTab($event)"
        />

        <div>
            <div>
                <gnetRecordHeader
                    v-bind:object="'account'"
                    v-bind:title="title"
                    
                    v-bind:fields="quotazionicols.filter( c => c.type != 'hidden')"
                    v-bind:actions="headlineActions"
                    v-on:click="actionClick($event)"
                />
            </div>
        </div>

        <div class="slds-grid slds-gutters">
            <!-- RICERCA -->
            <div class="slds-col slds-size--1-of-3 slds-m-around--x-small">
                <div class="slds-box slds-theme_default" style="position:sticky; top:7px;">
                    <div class="slds-col slds-text-align--right">
                        <button class="slds-button slds-button_brand" @click="showImport = true">Import</button>
                    </div>

                    <div class="field-label is-small pl-1">
                        <label class="label">Search</label>
                    </div>
                    <div class="field-body">
                        <input class="slds-input" v-model="searchText" type="search" v-on:keyup="compilingOptions()">
                        <label>{{ this.prods.length }} prodotti trovati</label>
                    </div>

                    <div class="slds-text-align--left slds-m-vertical--x-small">
                        <button class="slds-button slds-button_icon-brand" @click="showModalFiltri()">
                            <svg class="slds-icon" aria-hidden="true">
                                <use xlink:href="/assets/icons/standard-sprite/svg/symbols.svg#filter"></use>
                            </svg>
                        </button>
                        <label v-if="this.checkedFiltri.length > 0" class="slds-p-left--small">{{ this.checkedFiltri.length }} filtri inseriti</label>
                    </div>

                    <!-- PRODOTTI -->
                    <div>
                        <div v-for="prod of prods" :key="prod.Id" class="slds-box slds-theme_shade slds-m-around--x-small">
                            <div class="slds-grid slds-gutters">
                                <div class="slds-col slds-size_1-of-3" style="padding: 0; height: 50px; width: 50px">
                                    <img v-if="prod.Digital_Assets__r && prod.Digital_Assets__r.records[0].URL__c" :src="prod.Digital_Assets__r.records[0].URL__c">
                                    <svg v-else class="slds-carousel__content slds-size--1-of-1" style="height:stretch" aria-hidden="true">
                                        <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#photo"></use>
                                    </svg>
                                </div>
                                <div class="slds-col slds-p-around--none">
                                    <div class="slds-grid">
                                        <div class="slds-col"><span class="pill">{{ prod.ProductCode }}</span></div>
                                        <div class="slds-col slds-text-align--right">{{ $store.getters.filter(prod.Pnb__c, 'currency') }}</div>
                                        <div><button class="slds-button slds-button_brand slds-button--reset" @click="add(prod)">+</button></div>
                                    </div>
                                    <div class="slds-grid slds-m-top--x-small">
                                        <div class="slds-col">{{ prod.Description }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="slds-col slds-m-around--x-small">
                <div class="slds-box slds-theme_default">

                    <div class="slds-box slds-theme_shade slds-m-around--x-small">
                        <div class="slds-grid slds-gutters">
                            <div class="slds-col slds-text-align--left">
                                <button class="slds-button slds-button_brand" v-on:click="showExportModal = true">Export</button>
                            </div>
                            <div class="slds-col slds-text-align--right slds-text-title_bold">Totale: {{ $store.getters.filter(record.Prezzo_Totale__c, 'currency') }}</div>
                        </div>
                    </div>

                    <!-- RIGHE -->
                    <div v-for="riga of righe" :key="riga.Id" class="slds-box slds-theme_shade slds-m-around--x-small">
                        <div class="slds-grid slds-gutters">
                            <div class="slds-col slds-size_1-of-12 slds-align-content-center" style="padding: 0;">
                                <button class="slds-button slds-button_destructive" @click="deleteRiga(riga)">
                                    <svg class="slds-button__icon slds-button__icon_small" aria-hidden="true">
                                        <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#delete"></use>
                                    </svg>
                                </button>
                            </div>
                            <div class="slds-col slds-size_1-of-4" style="padding: 0; height: 60px; width: 60px; margin-left: 15px">
                                <img v-if="righeImgsTracker > 0 && righeImgs.has(riga.Prodotto__c)" :src.lazy="righeImgs.get(riga.Prodotto__c)" width="200px" height="300">
                                <svg v-else class="slds-carousel__content slds-size--1-of-1" style="height:stretch" aria-hidden="true">
                                    <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#photo"></use>
                                </svg>
                            </div>
                            <div class="slds-col slds-p-around--none">
                                <div class="slds-grid">
                                    <div class="slds-col"><span class="pill">{{ riga.Prodotto__r.ProductCode }}</span> {{ riga.Descrizione__c }}</div>
                                </div>
                                <div class="slds-grid slds-m-top--x-small">
                                    <div class="slds-col slds-align-content-center">PVP {{ $store.getters.filter(riga.Prodotto__r.Pvp__c, 'currency') }}</div>
                                    <div class="slds-col slds-text-align--left">
                                        <input class="slds-size--1-of-4 slds-text-align--right" v-model="riga.Prezzo__c" type="text" @change="changePrezzo($event, riga)"/> x
                                        <button class="slds-button slds-button_brand slds-radio--button-group" style="border-radius: 16px 0px 0px 16px; font-size: large" @click="changeQta(riga, -1)">-</button>
                                        <button class="slds-button slds-button--icon-more slds-m-around_none">{{ riga.Quantita__c }}</button>
                                        <button class="slds-button slds-button_brand slds-m-around_none slds-radio--button-group" style="border-radius: 0px 16px 16px 0px; font-size: large" @click="changeQta(riga, 1)">+</button>
                                    </div>
                                    <div class="slds-col slds-text-align--right slds-text-title_bold slds-align-content-center">{{ $store.getters.filter(riga.Prezzo_Totale__c, 'currency') }}</div>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <!-- IMPORT MODAL -->
        <gnetModal v-if="showImport" title="Incollare i codici prodotto" @cancel="showImport = false" @submit="inserisciProdotti()">
            <label>Inserire un codice prodotto per riga.</label></br>
            <textarea rows="10" cols="50" v-model="codiciProdotto"></textarea>
        </gnetModal>

        <!-- EXPORT MODAL -->
        <gnetModal v-if="showExportModal" title="Product Export" @cancel="showExportModal = false" @submit="generaFile()">
            <div><label><b>*Selezionare le opzioni di download.</b></label></div>

            <label v-for="o of fileTypeOptions" :key="o.value" class="slds-m-right--medium">
                <input type="radio" :id="o.value" :value="o.value" v-model="fileType" /> <label :for="o.value">{{ o.label }}</label>
            </label>
            </br></br>
            <div v-for="f of fileFields" :key="f.fieldname">
                <input type="checkbox" :id="f.fieldname" :value="f" v-model="checkedFileFields" /> <label :for="f.fieldname">{{ f.label }}</label>
            </div>

        </gnetModal>

        <!-- FILTRI MODAL -->
        <gnetModal v-if="showFiltri" title="Filtri" @cancel="deleteFiltri()" @submit="saveFiltri()">

            <input type="search" placeholder="Cerca" class="slds-input slds-m-bottom--x-small" v-model="searchFiltro" @keyup="searchFiltri()" />

            <div v-for="f of Object.keys(filtri)" :key="f">
                <label><b>{{ filtri[f].label }}: </b></label>
                <div>
                    <span v-for="v in filtri[f].values" :key="v" class="slds-button_icon-container-more" style="margin:2px"
                        :class="{ 'selectedButton' : selectedFiltro(filtri[f].field, v), 'emptybutton' : !selectedFiltro(filtri[f].field, v) }" 
                        @click="setFiltri(filtri[f].field, v)"
                    >
                        {{ v }}
                    </span>
                </div>
            </div>

        </gnetModal>

        <!-- ALERT MODIFICHE -->
        <div v-if="showAlert" class="slds-box slds-theme--default alert">
            <span class="slds-text-not-selected">
                <svg class="slds-button__icon slds-button__icon_small slds-button__icon_left" aria-hidden="true">
                    <use :xlink:href="'/assets/icons/utility-sprite/svg/symbols.svg#'+alerts.get(alertType).symbol"></use>
                </svg>
                {{ alerts.get(alertType).text }}
            </span>
        </div>
    </div>
</template>

<script>

// @ is an alias to /src
import gnetHeader from '../components/header.vue'
import gnetTabBar from '../components/tabbar.vue'
import gnetRecordHeader from '../components/recordheader.vue'
import apiclient from '@/apiclient.js'
import gnetMixLib from '@/mixin.js'
import gnetModal from '../components/modal.vue';

import quotehelper from '@/quotehelper.js'

export default {
    name: 'Quotazione',
    mixins: [gnetMixLib],
    components: {
        gnetHeader,
        gnetTabBar,
        gnetRecordHeader,
        gnetModal
    },
    data: function() {
        return {
            recordId: '',
            record: {},

            quotazionicols: [
                { value:'', label:'Id', name:'Id', type:'hidden' },
                { value:'', label:'#', name:'Name', type:'hidden' },
                { value:'', label:'Cliente', name:'Account__r.Name', type:'string' },
                // { value:'', label:'Anno Campagna', name:'AnnoCampagna__c', type:'string' },
                { value:'', label:'Data Creazione', name:'CreatedDate', type:'date' },
                { value:'', label:'Titolo', name:'Titolo__c', type:'string' },
                { value:'', label:'# Articoli', name:'Quantita_articoli__c', type:'string' },
                { value:'', label:'# Pezzi', name:'Quantita_Pezzi__c', type:'string' },
                { value:'', label:'Totale', name:'Prezzo_Totale__c', type:'currency' }
            ],
            righequotazionicols: [
                { value:'', label:'Id', name:'Id', type:'hidden' },
                { value:'', label:'#', name:'Name', type:'hidden' },
                { value:'', label:'SKU', name:'Prodotto__r.ProductCode', type:'text' },
                { value:'', label:'Title', name:'Descrizione__c', type:'text' },
                { value:'', label:'EAN', name:'Prodotto__r.ITEMBARCODE__c', type:'text' },
                { value:'', label:'EU Wholesale Price', name:'Prezzo__c', type:'currency' },
                { value:'', label:'Quantità', name:'Quantita__c', type:'number' },
                { value:'', label:'Prezzo Totale', name:'Prezzo_Totale__c', type:'currency' },
                { value:'', label:'Prodotto ID', name:'Prodotto__c', type:'hidden' },
                { value:'', label:'Nome Prodotto', name:'Prodotto__r.Name', type:'text' },
                { value:'', label:'EU MSRP', name:'Prodotto__r.Pvp__c', type:'currency' },
                { value:'', label:'Ordinale', name:'Ordinale__c', type:'hidden' },
                { value:'', label:'Data Creazione', name:'CreatedDate', type:'hidden' },
                { value:'', label:'Linea', name:'Prodotto__r.Linea__c', type:'text' },
                { value:'', label:'Larghezza', name:'Prodotto__r.Pim_Larghezza__c', type:'number' },
                { value:'', label:'Altezza', name:'Prodotto__r.Pim_Altezza__c', type:'number' },
                { value:'', label:'Profondità', name:'Prodotto__r.Pim_Profondita__c', type:'number' },
                { value:'', label:'Capacità', name:'Prodotto__r.Pim_Capacita__c', type:'number' },

                // { label: 'Imm. ad alta risoluzione', fieldname: 'excel' },
                // { label: 'Sell Sheet', fieldname: 'excel' },
                // { label: 'Class', fieldname: 'excel' },
                // { label: 'UPC', fieldname: 'excel' },
                // { label: 'Split QTY', fieldname: 'excel' },
                // { label: 'Master Total SKU Qty', fieldname: 'excel' },
                // { label: 'Disponibilità', fieldname: 'excel' },
                // { label: 'Descrizione', fieldname: 'excel' },
                // { label: 'Categorie', fieldname: 'excel' },
                // { label: 'Regione del paese', fieldname: 'excel' },
                // { label: 'Data PO', fieldname: 'excel' },
                // { label: 'UK Wholesale Price', fieldname: 'excel' },
                // { label: 'KR Wholesale Price', fieldname: 'excel' },
                // { label: 'UK MSRP', fieldname: 'excel' },
                // { label: 'KR MSRP', fieldname: 'excel' },
                // { label: 'Inner Dimensions', fieldname: 'excel' },
                // { label: 'Inner Pack Quantity', fieldname: 'excel' },
                // { label: 'Master Dimensions', fieldname: 'excel' },
                // { label: 'Master Carton Quantity', fieldname: 'excel' },
            ],
            prodscols: [
                { value:'', label:'Id', name:'Id', type:'hidden' },
                { value:'', label:'#', name:'Name', type:'hidden' },
                { value:'', label:'Codice', name:'ProductCode', type:'text' },
                { value:'', label:'Nome', name:'Description', type:'text' },
                { value:'', label:'Prezzo', name:'Pnb__c', type:'currency' },
                { value:'', label:'Barcode', name:'ITEMBARCODE__c', type:'text' },
                { value:'', label:'Anno', name:'FCP_CAMPAIGNORIGYEAR__c', type:'date' }
            ],
            headlineActions: [ {title: 'Elimina', name:'delete', symbol:'delete', class:'slds-button--destructive'} ],

            searchText: '',
            dropdownInterval: undefined,

            prods: [],
            righe: [],
            righeImgs: new Map(),
            righeImgsTracker: 0,

            showImport: false,
            codiciProdotto: '',

            showAlert: false,
            alerts: new Map([
                ['add', { symbol: 'check', text: 'Prodotto inserito.'}],
                ['delete', { symbol: 'delete', text: 'Prodotto rimosso.'}]
            ]),
            showNoRecord: false,

            showExportModal: false,
            fileType: null,
            checkedFileFields: [
                { label:'SKU', fieldname:'Prodotto__r.ProductCode', type:'text' },
                { label:'Title', fieldname:'Descrizione__c', type:'text' },
                // { label:'EAN', fieldname:'Prodotto__r.ITEMBARCODE__c' },
                // { label:'Quantità', fieldname:'Quantita__c', type:'number' },
                // { label:'EU MSRP', fieldname:'Prodotto__r.Pvp__c', type:'currency' },
            ],
            fileTypeOptions: [
                { label: 'Excel', value: 'excel' },
                { label: 'PowerPoint', value: 'pp' },
                { label: 'Sellsheets PDF', value: 'pdf' },
            ],

            showFiltri: false,
            filtri: {
                anni: { label: 'Anni', field: 'FCP_CAMPAIGNORIGYEAR__c', allvalues: [], values: [] },
                linee: { label: 'Linee', field: 'Linea__c', allvalues: [], values: [] }
            },
            checkedFiltri: [],
            searchFiltro: ''
        };
    },
    watch: {
        '$route.params.id': function () {
            this.recordId=this.$route.params.id;
            if(this.recordId) this.getRecord()
        }
    },
    computed: {
        title: function() {
            var t = ''
            if (this.record) t += this.record.Name
            if (this.record.Titolo__c) t += ' - '+ this.record.Titolo__c
            return t
        },
        fileFields() {
            return this.righequotazionicols.filter( r => r.type != 'hidden').map( r => { return { label: r.label, fieldname: r.name, type: r.type } })
        },
        mappaFiltri() {
            var mf = new Map()
            this.checkedFiltri.forEach( f => {
                if(mf.has(f.field)) mf.get(f.field).push("'"+f.value+"'")
                else mf.set(f.field, ["'"+f.value+"'"])
            })
            return mf
        }
    },
    mounted: async function() {
        console.log('mounted quotazione', this.$route.params.id)
        this.recordId=this.$route.params.id;
        console.log('id', this.recordId)
        if(this.recordId) {
            await this.getQuotazione()
            this.getImmagini()
        }
    },
    methods: {
        async getQuotazione(){
            var soql = 'SELECT '+ Array.from(this.quotazionicols, c => c.name).join(', ')
            soql += ', ( SELECT '+ Array.from(this.righequotazionicols, c => c.name).join(', ') +' FROM Righe_Quotazioni__r ORDER BY Ordinale__c )'
            soql += ' FROM Quote__c'
            soql += ' WHERE Id = \''+this.recordId+'\'';

            var data = await this.getRecords(soql)

            this.record=data[0];
            this.recordId=data[0].Id;
            if(data[0].Righe_Quotazioni__r) this.righe = data[0].Righe_Quotazioni__r.records
            this.updateFieldsValue(this.quotazionicols);
        },
        async getImmagini(){
            if(!this.righe.length) return

            var prodIds = []
            this.righe.forEach( r => {
                prodIds.push("'"+r.Prodotto__c+"'")
            })

            var soql = 'SELECT Posizione__c, URL__c, Prodotto__c'
            soql += ' FROM Digital_Asset__c'
            soql += ' WHERE (Posizione__c = 1 OR Posizione__c = null) AND Prodotto__c IN ('+ prodIds.join(',') +')'

            var data = await this.getRecords(soql)

            data.forEach( r => {
                this.righeImgs.set(r.Prodotto__c, r.URL__c)
            })
            this.righeImgsTracker = data.length
        },
        getRecords(soql) {
            console.log('get records')
            console.log(soql);
            var self=this;
            return new Promise(function(resolve, reject) {

                apiclient.query(self.$store.getters.connection, soql)
                .then(function(data) {
                    console.log('records:'+data.length);
                    resolve(data);
                }).catch(function(err){
                    console.error(err);
                    reject();
                })
            })
        },
        compilingOptions() {
            console.log('search', this.searchText)
            const self = this;
            this.showNoRecord = false
            if (self.dropdownInterval) {
                clearInterval(self.dropdownInterval);
            }

            self.dropdownInterval = setInterval(function () {
                self.search()
                clearInterval(self.dropdownInterval);
            }, 500)
        },
        async search() {
            try {
                
                var soql = 'SELECT '+ Array.from(this.prodscols, c => c.name).join(', ')
                soql += ', ( SELECT Posizione__c, URL__c FROM Digital_Assets__r WHERE Posizione__c = 1 OR Posizione__c = null )'
                soql += ' FROM Product2'

                if(this.searchText) {
                    var text = this.searchText.replaceAll(' ', '%')
                    soql += ' WHERE ( Description LIKE \'%'+ text +'%\' OR ProductCode LIKE \'%'+ text +'%\''
                    soql += ' OR ITEMBARCODE__c LIKE \'%'+ text +'%\' )' // EAN CODE
                }

                if(this.checkedFiltri.length > 0) {
                    var filters = []
                    this.mappaFiltri.forEach(function(value, key) {
                        filters.push(key+' IN ('+value.join(',')+')')
                    })
                    console.log(filters)
                    soql += (!this.searchText ? ' WHERE ' : ' AND ') + filters.join(' AND ')
                }

                soql += ' ORDER BY ProductCode, Description'

                var data = await this.getRecords(soql)

                console.log('prods', data)
                this.prods = data
                if(this.prods.length == 0) this.showNoRecord = true

            } catch (error) {
                console.error('search err', error);
            }
        },
        add(prod) {
            if(this.checkCodicePresente(prod)) {
                this.setShowAlert('add')
                return
            }

            var record = {
                Quotazione__c: this.recordId,
                Prodotto__c: prod.Id,
                ITEMBARCODE__c: prod.ITEMBARCODE__c,
                Prezzo__c: prod.Pnb__c,
                Descrizione__c: prod.Description,
                Quantita__c: 1,
                Ordinale__c: this.righe.length+1
            }
            apiclient.create(this.$store.getters.connection, 'Quote_Line__c', record)
            .then(async resp => {
                console.log('riga', resp)
                this.setShowAlert('add')
                await this.getQuotazione()
                this.getImmagini()
            }).catch( e => {
                console.error(e);
            })
        },
        async inserisciProdotti() {
            if(this.codiciProdotto) {
                var codici = this.codiciProdotto.replaceAll('\n',"','")

                var soql = 'SELECT Id, ProductCode, Pnb__c, Description, ITEMBARCODE__c'
                soql += ' FROM Product2'
                soql += ' WHERE ProductCode IN (\''+ codici +'\') AND ProductCode != \'\''
                soql += ' ORDER BY ProductCode, Description'
                soql += ' LIMIT 10'

                var prods = await this.getRecords(soql)

                console.log('prods', prods)

                if(codici.split(',').length != prods.length) {
                    var alertMsg = 'Alcuni codici non sono stati trovati: '
                    var codiciToCheck = this.codiciProdotto.split('\n')
                    const prodottiTrovati = new Map(prods.map((p) => [p.ProductCode, p]))
                    var showAlertMsg = false
                    for(var c of codiciToCheck) {
                        if(!c) continue
                        if(!prodottiTrovati.has(c)) {
                            alertMsg += c+', '
                            showAlertMsg = true
                        }
                    }
                    if(showAlertMsg) alert(alertMsg)
                }

                var righe = []
                for(var p of prods) {
                    if(this.checkCodicePresente(p)) continue

                    var record = {
                        Quotazione__c: this.recordId,
                        Prodotto__c: p.Id,
                        Prezzo__c: p.Pnb__c,
                        ITEMBARCODE__c: p.ITEMBARCODE__c,
                        Descrizione__c: p.Description,
                        Quantita__c: 1
                    }
                    righe.push(record)
                }
                console.log('righe da creare', righe)
                if(righe.length > 0) {
                    apiclient.bulkcreate(this.$store.getters.connection, 'Quote_Line__c', righe)
                    .then(async resp => {
                        console.log(resp)
                        this.codiciProdotto = ''
                        this.setShowAlert('add')
                        await this.getQuotazione()
                        this.getImmagini()
                    }).catch( e => {
                        console.error(e);
                    })
                } else {
                    this.codiciProdotto = ''
                    this.setShowAlert('add')
                }
            }
            this.showImport = false
        },
        checkCodicePresente(prod) {
            if(this.righe.find( r => r.Prodotto__r.ProductCode == prod.ProductCode)) return true
            return false
        },
        deleteRiga(riga) {
            console.log('delete')

            apiclient.delete(this.$store.getters.connection, 'Quote_Line__c', riga.Id)
            .then(async resp => {
                console.log(resp)
                this.codiciProdotto = ''
                this.setShowAlert('delete')
                await this.getQuotazione()
            }).catch( e => {
                console.error(e);
            })
        },
        changeQta(riga, diff) {
            riga.Quantita__c += diff
            var record = { Quantita__c: riga.Quantita__c }

            apiclient.update(this.$store.getters.connection, 'Quote_Line__c', riga.Id, record)
            .then(async resp => {
                console.log(resp)
                await this.getQuotazione()
            }).catch( e => {
                console.error(e);
            })
        },
        changePrezzo(event, riga) {
            console.log(event.target.value)
            riga.Prezzo__c = event.target.value
            var record = { Prezzo__c: riga.Prezzo__c}

            apiclient.update(this.$store.getters.connection, 'Quote_Line__c', riga.Id, record)
            .then(async resp => {
                console.log(resp)
                await this.getQuotazione()
            }).catch( e => { console.error(e) })
        },
        setShowAlert(type) {
            this.alertType = type
            this.showAlert = true
            var self = this
            setInterval(function() { self.showAlert = false }, 3000);
        },
        generaFile() {
            console.log('tipo file',this.fileType)
            switch(this.fileType) {
                case 'excel':
                    this.createXLS()
                    break
                case 'pp':
                    this.createPPT()
                    break
                case 'pdf':
                    this.createPDF()
                    break
            }
        },
        /**
         * export PPT current quote lines
         */
        createPPT() {
            console.log(quotehelper.generatePPT);
            
            quotehelper.generatePPT(this.righe, this.righeImgs, this.checkedFileFields);
        },
        /**
         * export PPT current quote lines
         */
        async createXLS() {
            await quotehelper.generateXLSX(this.righe, this.righeImgs, this.checkedFileFields);
        },
        /**
         * export PPT current quote lines
         */
        async createPDF() {
            await quotehelper.generatePDF(this.righe, this.righeImgs, this.checkedFileFields);
        },
        async showModalFiltri() {

            // get anni
            if(!this.filtri.anni.allvalues.length) {
                var field = 'FCP_CAMPAIGNORIGYEAR__c'
                var soql = 'SELECT '+field+' FROM Product2 group by '+field+' order by '+field+' desc'
                var anni = await this.getRecords(soql)
                anni.forEach(a => {
                    if(a[field]) this.filtri.anni.allvalues.push(a[field])
                    if(a[field]) this.filtri.anni.values.push(a[field])
                })
            }

            // get linee
            if(!this.filtri.linee.allvalues.length) {
                var field = 'Linea__c'
                var soql = 'SELECT '+field+' FROM Product2 group by '+field+' order by '+field
                var linee = await this.getRecords(soql)
                linee.forEach(a => {
                    if(a[field]) this.filtri.linee.allvalues.push(a[field])
                    if(a[field]) this.filtri.linee.values.push(a[field])
                })
            }

            this.showFiltri = true
        },
        setFiltri(fieldname, value) {
            var index = this.checkedFiltri.findIndex(f => f.field == fieldname && f.value == value)
            if(index >= 0) this.checkedFiltri.splice(index, 1)
            else this.checkedFiltri.push({ field: fieldname, value: value })
        },
        selectedFiltro(fieldname, value) {
            var index = this.checkedFiltri.findIndex(f => f.field == fieldname && f.value == value)
            if(index >= 0) return true
            return false
        },
        searchFiltri() {
            console.log('search filtro '+this.searchFiltro)
            for(var filtro of Object.values(this.filtri)) {
                filtro.values = []

                if(this.searchFiltro == '') {
                    filtro.values = filtro.allvalues
                    continue
                }
                let re = new RegExp(this.searchFiltro, "i");
                for(var v of filtro.allvalues) {
                    if(v.search(re) > -1) filtro.values.push(v)
                }
                console.log(filtro.values)
            }
        },
        deleteFiltri() {
            this.searchFiltro = ''
            this.checkedFiltri = []
            this.showFiltri = false
            if(this.searchText) this.search()
        },
        saveFiltri() {
            this.showFiltri = false; 
            this.searchFiltro = ''
            this.searchFiltri()
            this.search()
        },
        actionClick: function(e) {
            console.log(e);
            switch (e) {
                case 'delete':
                    this.deleteTestata()
                break;
            }    
        },
        deleteTestata() {
            console.log('delete')
            if(!confirm('Vuoi eliminare il catalogo?')) return

            apiclient.delete(this.$store.getters.connection, 'Quote__c', this.record.Id)
            .then(async resp => {
                console.log(resp)
                this.$router.go(-1)
            }).catch( e => {
                console.error(e);
            })
        }
    }
}
</script>